import type { TarjetasCxc } from '@leadsphere/types';

import { fmtMXN, fmtPct } from '../../lib/moneda.js';

function Tarjeta({ etiqueta, valor, sub, clase = '' }: { etiqueta: string; valor: string; sub?: string; clase?: string }) {
  return (
    <div className={`stat-card ${clase}`}>
      <div className="stat-label">{etiqueta}</div>
      <div className="stat-value">{valor}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}

export function TarjetasResumen({ t }: { t: TarjetasCxc }) {
  return (
    <div className="stats-grid stats-grid-5">
      <Tarjeta
        etiqueta="Facturado"
        valor={fmtMXN(t.facturado)}
        sub={`Servicio ${fmtMXN(t.facturado_servicio)} · Adicional ${fmtMXN(t.facturado_adicional)}`}
        clase="hl"
      />
      <Tarjeta etiqueta="Cobrado" valor={fmtMXN(t.cobrado)} />
      <Tarjeta etiqueta="Por cobrar" valor={fmtMXN(t.por_cobrar)} />
      <Tarjeta etiqueta="% cobrado" valor={fmtPct(t.pct_cobrado)} />
      <Tarjeta
        etiqueta="Días promedio de cobro"
        valor={t.dias_promedio_cobro === null ? '—' : `${t.dias_promedio_cobro} días`}
        sub={`Con base en ${t.dias_promedio_n} cobros con fecha de pago`}
      />
    </div>
  );
}
